import { render, staticRenderFns } from "./AppButtonAddRpa.vue?vue&type=template&id=8e845b58&scoped=true&"
import script from "./AppButtonAddRpa.vue?vue&type=script&lang=ts&"
export * from "./AppButtonAddRpa.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonAddRpa.vue?vue&type=style&index=0&id=8e845b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e845b58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
